import React, { useEffect, memo } from "react";
import ErrorIconSvg from "@/assets/memberShip/images/errorIcon_svg.svg";
import InfoIconSvg from "@/assets/memberShip/images/24infoIconSvg.svg";
import SuccessIconSvg from "@/assets/memberShip/images/icon_success.svg";
import "./style.scss";
const IconSvgType = {
    error: <ErrorIconSvg />,
    info: <InfoIconSvg />,
    success: <SuccessIconSvg />,
};
const MemberTips = ({
    children,
    // iconSrc = "/login/images/24infoIcon.png",
    className = "",
    stateType = "info",
}) => {
    return (
        <div className={`tip-box ${className}`}>
            <div className="tip-icon">{IconSvgType[stateType]}</div>
            {children}
        </div>
    );
};

export default MemberTips;
